import { render, staticRenderFns } from "./relSugumDialog.vue?vue&type=template&id=08c7fe24"
import script from "./relSugumDialog.vue?vue&type=script&lang=js"
export * from "./relSugumDialog.vue?vue&type=script&lang=js"
import style0 from "./relSugumDialog.vue?vue&type=style&index=0&id=08c7fe24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports